export default __webpack_public_path__ + "static/media/im_1.566fcdc4.png";